import {Button} from 'antd';
import React from 'react';
import {translate} from 'react-i18next';
import EnhancedModal from "../../../../../components/enhanced-modal";
import {MODAL_WIDTH_LG} from "../../../../../styles/constants";
import InfiniteScrollDataTable from "../../../../../components/infinite-scroll-data-table";

const ObjectPreview = ({
                           t,
                           rows,
                           isRowsModalVisible,
                           onRowsModalHide,
                           fetchRows,
                           connId,
                           query,
                           title,
                           width,
                       }) => {
    return (
        <EnhancedModal
            visible={isRowsModalVisible}
            onCancel={onRowsModalHide}
            footer={<Button onClick={onRowsModalHide}>{t('commons.buttons.close.title')}</Button>}
            width={width || MODAL_WIDTH_LG}
            title={title || t('scenes.dataManager.dataflowBuilder.wizard.query.preview.rowsModal.title')}
        >
            <InfiniteScrollDataTable
                data={rows && rows.rows}
                cols={rows && rows.columns}
                rowTotal={rows && rows.totalRows}
                noSort
                onChange={
                    ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) => fetchRows(
                        {
                            connId,
                            limit: pageSize,
                            page: pageNum - 1,
                            query,
                            searchText,
                            filters,
                            sortCol,
                            sortByDesc,
                            rows
                        }
                    )
                }
            />
        </EnhancedModal>
    )
};

export default translate()(ObjectPreview);
